import { useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import { submitRating } from "@/lib/api";

export const RatingStars = ({ jobId }) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [done, setDone] = useState(false);

  const pick = async (n) => {
    if (done) return;
    setRating(n);
    try {
      await submitRating(jobId, n);
      setDone(true);
      toast.success("Thanks — your feedback helps us improve.");
    } catch {
      setRating(0);
      toast.error("Couldn't save your rating. Please try again.");
    }
  };

  return (
    <div
      className="flex items-center gap-3 flex-wrap"
      data-testid="feedback-rating"
    >
      <span className="text-sm text-ink-muted">
        {done ? "Thanks for rating this feedback." : "How useful was this feedback?"}
      </span>
      <div className="flex items-center gap-1" onMouseLeave={() => setHover(0)}>
        {[1, 2, 3, 4, 5].map((n) => {
          const active = (hover || rating) >= n;
          return (
            <button
              key={n}
              type="button"
              disabled={done}
              data-testid={`rating-star-${n}`}
              aria-label={`Rate ${n} out of 5`}
              onMouseEnter={() => !done && setHover(n)}
              onClick={() => pick(n)}
              className="p-0.5 disabled:cursor-default transition-transform hover:scale-110"
            >
              <Star
                className={`h-5 w-5 transition-colors ${
                  active ? "fill-amber-400 text-amber-400" : "text-ink-faint"
                }`}
                strokeWidth={2}
              />
            </button>
          );
        })}
      </div>
    </div>
  );
};
